import { render, staticRenderFns } from "./CoursewareBlockFeedback.vue?vue&type=template&id=12ba28fc&"
import script from "./CoursewareBlockFeedback.vue?vue&type=script&lang=js&"
export * from "./CoursewareBlockFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports